const translations = {
  ta: {
    app_title: "பொன்னி களஞ்சியம்",
    nav_ask_ai: "AI-யிடம் கேளுங்கள்",
    nav_library: "நூலகம்",
    nav_history: "வரலாறு",
    nav_about: "பற்றி",
    nav_toggle: "English",
    hero_input_placeholder: "பொன்னி வரலாறு பற்றி கேளுங்கள்...",
    sugg_founder: "பொன்னி இதழ் ஆசிரியர்கள்",
    sugg_poets: "பாரதிதாசன் எழுதிய கட்டுரைகள்",
    sugg_dravidian: "திராவிட இயக்கம்",
    sugg_archive: "வேண்டாத ஆசை ஆசிரியர்",
    lib_title: "பொன்னி மின் நூலகம்",
    lib_desc: "1947–1955 வரையிலான அரிய தொகுப்புகளை ஆராயுங்கள்.",
    lib_vol: "தொகுதி",
    lib_back: "நூலகத்திற்கு திரும்பு",
    lib_back_issues: "இதழ்களுக்கு திரும்பு",
    sources_title: "ஆதாரங்கள்",
    source_title: "ஆதாரம்",
    searching: "தேடுகிறது...",
    issue: "இதழ்",
    issue_label: "இதழ்",
    malar_label: "மலர்",
    title_label: "தலைப்பு",
    author_label: "எழுத்தாளர்",
    read_more: "மேலும் படிக்க",
    show_less: "குறைவாக காட்டு",
    open_pdf: "PDF-ஐ புதிய தாவலில் திற",
    error_message: "மன்னிக்கவும், பிழை ஏற்பட்டது",
    loading_pdf: "PDF ஏற்றுகிறது...",
    error_loading_pdf: "PDF ஏற்றுவதில் பிழை",
    pdf_not_available: "இந்த இதழுக்கு PDF கிடைக்கவில்லை.",
    no_images: "இந்த தொகுதிக்கு படங்கள் இல்லை",
    nav_tags: "வகைகள்",
    browse_tags: "கட்டுரை வகைகள்",
    browse_tags_desc: "பொன்னி இதழின் கட்டுரைகளை வகை வாரியாக ஆராயுங்கள்.",
    filter_by_category: "வகை வடிகட்டி",
    articles_in_category: "கட்டுரைகள்",
    articles_count: "கட்டுரைகள்",
    back_to_tags: "வகைகளுக்கு திரும்பு",
    clear_filters: "வடிகட்டிகளை நீக்கு",
    untitled: "தலைப்பு இல்லை",
    tags_library_nav: "கட்டுரை வகைகள்",
    tags_all_categories: "அனைத்து வகைகள்",
    tags_search_placeholder: "கட்டுரைகள் தேடுங்கள்...",
    tags_results_found: "முடிவுகள் கிடைத்தன",
    tags_files: "கோப்புகள்",
    tags_select_issue: "கட்டுரைகளைக் காண ஒரு இதழைத் தேர்ந்தெடுக்கவும்",
    tags_read_pdf: "PDF படிக்க",
    tags_back_to_articles: "கட்டுரைகளுக்கு திரும்பு",
    tags_no_articles: "கட்டுரைகள் எதுவும் இல்லை",
    tags_word_count: "சொற்கள்",
    tags_collection: "தொகுப்பு",
    tags_volume_label: "மலர்",
    gathering_evidence: "ஆதாரங்களைச் சேகரிக்கிறது...",
    nav_dataset: "தரவுத்தொகுப்பு",
    ds_title: "பொன்னி உரைத்தொகுப்பு",
    ds_subtitle:
      "1947–1955 பொன்னி இதழ்களின் OCR மூலம் பெறப்பட்டு கைமுறையாகத் திருத்தப்பட்ட தமிழ் உரை, ஆய்வுக்காக வெளியிடப்படுகிறது.",
    ds_version: "பதிப்பு",
    ds_open_heading: "வெளிப்படையான பதிவிறக்கங்கள்",
    ds_open_note: "CC BY 4.0 உரிமத்தின் கீழ். கோரிக்கை தேவையில்லை.",
    ds_gated_heading: "முழு உரைத்தொகுப்பு",
    ds_gated_note:
      "பொன்னி 1947–1955-இல் வெளியானது; தனிப்பட்ட படைப்புகளின் பதிப்புரிமை நிலை வேறுபடுகிறது. எனவே முழுத் தொகுப்பு, வணிகம் அல்லாத ஆய்வு மற்றும் கல்விப் பயன்பாட்டுக்கான தரவுப் பயன்பாட்டு ஒப்பந்தத்தின் கீழ் வழங்கப்படுகிறது.",
    ds_form_heading: "முழுத் தொகுப்பைக் கோருங்கள்",
    ds_form_intro:
      "படிவத்தை நிரப்பினால், பதிவிறக்க இணைப்பு உங்கள் மின்னஞ்சலுக்கு உடனே அனுப்பப்படும். இது ஒப்புதல் வடிகட்டி அல்ல — பயன்பாட்டைப் பதிவு செய்யவும் ஒப்பந்தத்தை இணைக்கவும் மட்டுமே.",
    ds_name: "பெயர்",
    ds_email: "மின்னஞ்சல்",
    ds_affiliation: "நிறுவனம்",
    ds_affiliation_ph: "பல்கலைக்கழகம், நிறுவனம், அல்லது 'தனிநபர்'",
    ds_intended_use: "பயன்பாட்டு நோக்கம்",
    ds_intended_use_ph:
      "இத்தொகுப்பை எவ்வாறு பயன்படுத்த உள்ளீர்கள் என்பதைச் சுருக்கமாக எழுதுங்கள் (குறைந்தது 20 எழுத்துகள்).",
    ds_accept_license: "தரவுப் பயன்பாட்டு ஒப்பந்தத்தை ஏற்கிறேன்",
    ds_read_license: "உரிமத்தைப் படிக்க",
    ds_submit: "பதிவிறக்க இணைப்பைக் கோரு",
    ds_submitting: "அனுப்புகிறது...",
    ds_success: "கோரிக்கை பெறப்பட்டது.",
    ds_request_id: "கோரிக்கை எண்",
    ds_contact_note: "கேள்விகள் அல்லது வணிகப் பயன்பாட்டு அனுமதிக்கு:",
    ds_cite_heading: "மேற்கோள்",
    ds_error: "கோரிக்கையை அனுப்ப முடியவில்லை.",
    ds_download: "பதிவிறக்கு",
  },
  en: {
    app_title: "Ponni Archive",
    nav_ask_ai: "Ask AI",
    nav_library: "Library",
    nav_history: "History",
    nav_about: "About",
    nav_toggle: "தமிழ்",
    hero_input_placeholder: "Ask about Ponni history...",
    sugg_founder: "Writers of Ponni Magazine",
    sugg_poets: "Articles by Bharathidasan",
    sugg_dravidian: "Dravidian Movement",
    sugg_archive: "The Unwanted Desire Teacher",
    lib_title: "Ponni Digital Library",
    lib_desc: "Browse restored volumes from 1947–1955.",
    lib_vol: "Volume",
    lib_back: "Back to Library",
    lib_back_issues: "Back to Issues",
    sources_title: "Sources",
    source_title: "Source",
    searching: "Searching...",
    issue: "Issue",
    issue_label: "Issue",
    malar_label: "Malar",
    title_label: "Title",
    author_label: "Author",
    read_more: "Read More",
    show_less: "Show Less",
    open_pdf: "Open PDF in new tab",
    error_message: "Sorry, an error occurred",
    loading_pdf: "Loading PDF...",
    error_loading_pdf: "Error loading PDF",
    pdf_not_available: "PDF not available for this issue.",
    no_images: "No images configured for this volume",
    nav_tags: "Categories",
    browse_tags: "Article Categories",
    browse_tags_desc: "Browse Ponni magazine articles by category.",
    filter_by_category: "Filter by Category",
    articles_in_category: "Articles",
    articles_count: "articles",
    back_to_tags: "Back to Categories",
    clear_filters: "Clear Filters",
    untitled: "Untitled",
    tags_library_nav: "Library Navigation",
    tags_all_categories: "All Categories",
    tags_search_placeholder: "Search articles...",
    tags_results_found: "results found",
    tags_files: "files",
    tags_select_issue: "Select an issue to view articles",
    tags_read_pdf: "Read PDF",
    tags_back_to_articles: "Back to Articles",
    tags_no_articles: "No articles found",
    tags_word_count: "Words",
    tags_collection: "Collection",
    tags_volume_label: "Volume",
    gathering_evidence: "Gathering evidence...",
    nav_dataset: "Dataset",
    ds_title: "Ponni Corpus",
    ds_subtitle:
      "The OCR-extracted, manually proofread Tamil text of the Ponni magazine (1947–1955), released for research.",
    ds_version: "Version",
    ds_open_heading: "Open downloads",
    ds_open_note: "Released under CC BY 4.0. No request needed.",
    ds_gated_heading: "Full corpus",
    ds_gated_note:
      "Ponni was published between 1947 and 1955 and the copyright status of individual contributions varies, so the full text is released under a data use agreement permitting non-commercial research, scholarly and educational use rather than under a Creative Commons licence.",
    ds_form_heading: "Request the full corpus",
    ds_form_intro:
      "Complete the form and a download link is emailed to you immediately. This is not an approval gate — the step records use and attaches the agreement.",
    ds_name: "Name",
    ds_email: "Email",
    ds_affiliation: "Affiliation",
    ds_affiliation_ph: "University, organisation, or 'independent'",
    ds_intended_use: "Intended use",
    ds_intended_use_ph:
      "Briefly describe how you intend to use the corpus (at least 20 characters).",
    ds_accept_license: "I accept the Ponni Archive Data Use Agreement",
    ds_read_license: "Read the licence",
    ds_submit: "Request download link",
    ds_submitting: "Submitting...",
    ds_success: "Request received.",
    ds_request_id: "Request ID",
    ds_contact_note: "Questions, corrections, or commercial permission:",
    ds_cite_heading: "How to cite",
    ds_error: "Could not submit the request.",
    ds_download: "Download",
  },
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || key;
};

export default translations;
